import React from 'react';
import { render } from 'react-dom';

import NewsListing from '../react/NewsListing';

export default class NewsListingRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { apiUrl, model } = this.context.dataset;
    if (!apiUrl || !model) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);

    render(<NewsListing {...jsonModel} apiURL={apiUrl} />, this.context);
  }
}
